import { _post, _get, _delete } from "./Axios";

export default class TargetKonsolidasiApi {
  static getByParams(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("target-konsolidasi/?" + params);
  }
  static getDetail(id) {
    return _get("target-konsolidasi/detail/" + id);
  }
  static create(data) {
    return _post("target-konsolidasi/", data);
  }
  static update(id, data) {
    return _post("target-konsolidasi/detail/" + id, data);
  }
  static delete(id) {
    return _delete("target-konsolidasi/"+ id);
  }
}
